import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './Auth.css';

const Login: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const { loginWithGoogle } = useAuth();
  const navigate = useNavigate();

  const handleGoogleSignIn = async () => {
    setLoading(true);
    setError('');

    try {
      await loginWithGoogle();
      navigate('/dashboard');
    } catch (error: any) {
      setError('Login failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-header">
          <h1>🦌 culr.app</h1>
          <h2>Login</h2>
        </div>

        {error && <div className="error-message">{error}</div>}

        <div className="auth-form">
          <button 
            onClick={handleGoogleSignIn} 
            className="google-signin-btn"
            disabled={loading}
          >
            {loading ? 'Signing in...' : '🔐 Sign in with Google'}
          </button>
        </div>

        <div className="auth-footer">
          <p>
            <Link to="/">Back to Home</Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;